import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { mapStateToProps } from './mapStateToProps';
import { mapDispatchToProps } from './mapDispatchToProps';
import BookingSectionTimesGridWrapper from './BookingSectionTimesGridWrapper';
import { Resolver } from '../../../config/mockable';

const BookingSectionTimesGridWrapperConnected = (
    connect(mapStateToProps, mapDispatchToProps)(
        withRouter(
            BookingSectionTimesGridWrapper
        )
    )
);

const bookingSectionTimesGridWrapperResolver = () => BookingSectionTimesGridWrapperConnected;

const BookingSectionTimesGridWrapperMockable = props => (
    <Resolver bookingSection={bookingSectionTimesGridWrapperResolver}>
        {({ bookingSection: BookingSectionResolved }) => <BookingSectionResolved {...props} />}
    </Resolver>
);

export {
    bookingSectionTimesGridWrapperResolver,
    BookingSectionTimesGridWrapperMockable as default,
};

